export const WEEKLY = "weekly";
export const DAILY = "daily";
export const MONTHLY = "monthly";
export const ONCE = "once";

export const frequencyTypes = [DAILY, WEEKLY, MONTHLY];
